import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxRadio } from 'src/shared/components/CheckboxRadio';

import { answersMap } from '../models/intakeForm';
import { FloatingLabel } from './FloatingLabel';

interface Props {
    questionId: string;
    questionText: string;
    response: string[];
    handleResponseChange: (questionId: string, value: string[]) => void;
}

export const CheckboxWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

export const CheckboxItemWrapper = styled('div')({
    '&> .ant-checkbox-wrapper': { display: 'flex' },
});

export const StyledCheckboxRadio = styled(CheckboxRadio)({
    display: 'flex',
});

// This component is not very re-usable; it's a bit of a unicorn for our single multi-select intake
// form question.
export const ReviewInputMulti: React.FC<Props> = ({
    questionText,
    response,
    handleResponseChange,
    questionId,
}) => {
    const [responseArray, setResponseArray] = useState(response || []);
    const { t } = useTranslation();

    const handleCheckBoxToggle = (value: string) => {
        let nextResponses: string[] = [];

        const alreadySelected = responseArray.includes(value);
        if (alreadySelected) {
            nextResponses = responseArray.filter(x => x !== value);
        } else {
            const noExperienceValue = 'NO_EXPERIENCE';
            // the first and second answers can be selected together but if user decide to select the third answer
            // we have to unselect the first two since the answers are contradictory
            if (value === noExperienceValue) {
                nextResponses = [noExperienceValue];
            } else {
                nextResponses = responseArray.filter(x => x !== noExperienceValue);
                nextResponses = [...nextResponses, value];
            }
        }

        setResponseArray(nextResponses);
        handleResponseChange(questionId, nextResponses);
    };

    return (
        <>
            <FloatingLabel>{t(questionText)}</FloatingLabel>
            <CheckboxWrapper>
                {Object.values(answersMap).map(({ text, value }) => (
                    <CheckboxItemWrapper key={value}>
                        <CheckboxRadio
                            inLine={false}
                            key={value}
                            value={value}
                            label={t(text)}
                            checked={responseArray?.includes(value) ?? false}
                            onChange={() => handleCheckBoxToggle(value)}
                        />
                    </CheckboxItemWrapper>
                ))}
            </CheckboxWrapper>
        </>
    );
};
